import { render, staticRenderFns } from "./SpeakerTopicHeader.vue?vue&type=template&id=53d256c6&"
import script from "./SpeakerTopicHeader.vue?vue&type=script&lang=js&"
export * from "./SpeakerTopicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports